/*


const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1 && node.matches('.mini-cart')) {
        console.log('Mini-cart added to DOM');
        // You can now safely add listeners or run logic
        node.querySelector('#second_submitbutton')?.addEventListener('click', () => {
          const checkbox = document.getElementById('accept-terms');
  if (checkbox && checkbox.checked) {
    const checkoutButton = document.querySelector('button.button[name="checkout"][type="submit"]');
    checkoutButton?.click();
  }else {
    document.querySelector("#terms-error").style.display = "block"
  }
        });
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
*/
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1 && node.matches('.mini-cart')) {
        console.log('Mini-cart added to DOM');

        // Handle submit button click
        node.querySelector('#second_submitbutton')?.addEventListener('click', () => {
          const checkbox = document.getElementById('accept-terms');
          if (checkbox && checkbox.checked) {
            const checkoutButton = document.querySelector('button.button[name="checkout"][type="submit"]');
            checkoutButton?.click();
          } else {
            document.querySelector("#terms-error").style.display = "block";
          }
        });

        // Add change listener to checkbox to hide error when checked
        const checkbox = node.querySelector('#accept-terms');
        if (checkbox) {
          checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
              document.querySelector("#terms-error").style.display = "none";
            }
          });
        }
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });


document.querySelectorAll('.swatch-input__label.swatch-input__label--variant')
  .forEach(label => {
    label.addEventListener('click', function () {
      const submitButton = document.querySelector('.product-form__submit');
      const priceSection = document.querySelector('.pf_price_and_discount_section');

      if (!submitButton || !priceSection) return;

      // Disable the submit button initially
      submitButton.disabled = true;

      // Set up a one-time event listener for changes inside the price section
      const observer = new MutationObserver(() => {
        // Delay re-enabling the button by 1 second
        setTimeout(() => {
          submitButton.disabled = false;
        }, 1000);

        observer.disconnect(); // Stop watching after the first change
      });

      observer.observe(priceSection, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  });